<template>
<div class="source-code">
  <el-collapse accordion>
    <!-- eslint-disable-next-line vue/no-use-v-if-with-v-for -->
    <el-collapse-item v-if="item.codeArray.length"
      v-for="(item, index) in stack" :key="index"
    >
      <template slot="title">{{ item.file }}</template>

      <div>
        <code>
          <div class="code-line" v-for="(code, line) in item.codeArray" :key="line">
            <div
              class="code-line-number"
            >{{ code.line }}
            </div>
            <pre :class="{ 'hight-line': code.heightLight }">
              {{ code.message }}
            </pre>
          </div>
        </code>
      </div>

    </el-collapse-item>
  </el-collapse>
</div>
</template>
<script>
export default {
  props: {
    stack: Array,
  },
};
</script>
<style scoped lang="scss">
.source-code {
  word-wrap: break-word;

  code {
    line-height: 1;
    color: #333;
    // padding: 0;
    margin-bottom: 0;
  }

  pre {
    margin: 0;
    padding: 0;
    font-size: 12px;
    line-height: 1.2;
    text-align: left;
    box-sizing: content-box;
  }
}

.code-line-number {
  margin-right: 10px;
  position: absolute;
  left: 0;
  top: -1px;
}
.code-line {
  text-align: left;
  padding: 0px;
  position: relative;
  color: #333;
  line-height: 20px;
}

.hight-line {
  &::before {
    position: absolute;
    content: "";
    width: 100%;
    height: 26px;
    background-color: rgba(0, 36, 255, .2);
    left: 0;
    top: -5px;
  }
}
</style>
